<script>
export default {
    name: 'NodePayload',
    props: {
        node: null
    },
    computed: {
        content () {
            if (this.node && this.node.config) { return this.node.config.content }
            return null
        },
        payloadContent () {
            return [
                {
                    step: this.content ? this.content.split('#')[0] : '-',
                    data: this.content && this.content.split('#')[1] ? this.content.split('#')[1] : '-',
                    name: this.content ? this.content.split('#')[2] : '-'
                }
            ]
        }
    },
    methods: {
        change () {
            this.$emit('repaint')
        }
    }
}
</script>

<template>
<el-collapse style="border: none" @change="change">
  <el-collapse-item>
    <template slot="title">
      <div class="d-flex align-center" style="gap: 12px">
        <div class="user-input-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
                d="M17.1667 18.3333H15.5V16.6667C15.5 15.2859 14.3808 14.1667 13 14.1667H8.00004C6.61933 14.1667 5.50004 15.2859 5.50004 16.6667V18.3333H3.83337V16.6667C3.83337 14.3655 5.69886 12.5 8.00004 12.5H13C15.3012 12.5 17.1667 14.3655 17.1667 16.6667V18.3333ZM10.5 10.8333C7.73862 10.8333 5.50004 8.59476 5.50004 5.83334C5.50004 3.07192 7.73862 0.833344 10.5 0.833344C13.2615 0.833344 15.5 3.07192 15.5 5.83334C15.5 8.59476 13.2615 10.8333 10.5 10.8333ZM10.5 9.16668C12.341 9.16668 13.8334 7.67429 13.8334 5.83334C13.8334 3.99239 12.341 2.50001 10.5 2.50001C8.65909 2.50001 7.16671 3.99239 7.16671 5.83334C7.16671 7.67429 8.65909 9.16668 10.5 9.16668Z"
                fill="white"/>
          </svg>
        </div>
        <span class="font-weight-bold">Payload Input:</span>
      </div>
    </template>
      <span class="font-weight-bold">{{ $t('content') | capitalize }}:</span>
      <el-table border :data="payloadContent" show-overflow-tooltip>
          <el-table-column
              prop="step"
              :label="$t('step') | capitalize">
          </el-table-column>
          <el-table-column
              prop="data"
              :label="$t('data') | capitalize">
          </el-table-column>
          <el-table-column
              prop="name"
              :label="$t('name') | capitalize">
          </el-table-column>
      </el-table>
  </el-collapse-item>
</el-collapse>
</template>

<style scoped lang="scss">
.user-input-icon {
  background-color: #50E41C;
  border-radius: 4px;
  padding: 4px;
  display: flex;
  align-items: center;
}
</style>
